export default "__VITE_ASSET__28cee758__"